// UsbOrdersQuickStats.jsx — v6.45.7 live counts tile for the Super
// Admin Dashboard's Sealed USB tab. Shows ops the queue pressure at a
// glance so they don't have to open the hub to know how many orders
// are waiting. Polls /api/usb-orders/counts every 20s.
import React, { useEffect, useState } from "react";
import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL;

const STATS = [
  { key: "new",           label: "New",           color: "#2563EB", bg: "#DBEAFE" },
  { key: "incomplete",    label: "Incomplete",    color: "#F59E0B", bg: "#FEF3C7" },
  { key: "authorized",    label: "Authorized",    color: "#4F46E5", bg: "#E0E7FF" },
  { key: "building",      label: "Building",      color: "#D97706", bg: "#FEF3C7" },
  { key: "qc_pending",    label: "QC Pending",    color: "#9333EA", bg: "#F3E8FF" },
  { key: "qc_passed",     label: "Ready to Ship", color: "#16A34A", bg: "#DCFCE7" },
  { key: "shipped",       label: "Shipped",       color: "#059669", bg: "#D1FAE5" },
  { key: "build_failed",  label: "Build Failed",  color: "#DC2626", bg: "#FEE2E2" },
];

const UsbOrdersQuickStats = () => {
  const [counts, setCounts] = useState({});
  const [err, setErr] = useState(null);

  useEffect(() => {
    const load = async () => {
      try {
        const { data } = await axios.get(`${API}/api/usb-orders/counts`);
        setCounts(data.counts || {});
        setErr(null);
      } catch (e) {
        setErr(e?.response?.data?.detail || e.message || "Load failed");
      }
    };
    load();
    const iv = setInterval(load, 20000);
    return () => clearInterval(iv);
  }, []);

  const total = Object.values(counts).reduce((a, b) => a + b, 0);

  return (
    <div
      data-testid="sa-usb-orders-quick-stats"
      style={{
        display: "grid",
        gridTemplateColumns: "repeat(auto-fill, minmax(130px, 1fr))",
        gap: 10,
        marginTop: 4,
      }}
    >
      {STATS.map((s) => {
        const n = counts[s.key] || 0;
        return (
          <a
            key={s.key}
            href={`/admin/sealed-usb#${s.key}`}
            data-testid={`sa-usb-stat-${s.key}`}
            style={{
              display: "block",
              padding: "10px 12px",
              background: n > 0 ? s.bg : "#F8FAFC",
              border: `1px solid ${n > 0 ? s.color + "55" : "#E2E8F0"}`,
              borderRadius: 8,
              textDecoration: "none",
              color: "inherit",
              transition: "transform .12s",
            }}
          >
            <div style={{ fontSize: 11, color: s.color, fontWeight: 700,
                           letterSpacing: ".04em", textTransform: "uppercase" }}>
              {s.label}
            </div>
            <div style={{ fontSize: 22, fontWeight: 800, color: n > 0 ? s.color : "#94A3B8",
                           marginTop: 2 }}>
              {n}
            </div>
          </a>
        );
      })}
      {err && (
        <div style={{
          gridColumn: "1 / -1", padding: 10, background: "#FEF2F2",
          color: "#991B1B", borderRadius: 6, fontSize: 12,
        }}>
          Could not fetch USB-order counts: {String(err)}
        </div>
      )}
      {!err && total === 0 && (
        <div style={{
          gridColumn: "1 / -1", padding: 10, background: "#F1F5F9",
          color: "#64748B", borderRadius: 6, fontSize: 12,
        }}>
          No active USB orders yet. New paid orders will appear here automatically.
        </div>
      )}
    </div>
  );
};

export default UsbOrdersQuickStats;
